import React, {useState, useEffect} from 'react'
import {connect} from "react-redux";
import {CardBody, Col, Form, FormGroup, Label, Row} from "reactstrap";
import SelectGeneric from "../../../components/select/selectGeneric";
import {ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";

import { FL_PLACE } from "../../../components/i18n/formLabels";
import { placeProvider } from "../../../providers/placeProvider";
import {useForm} from "react-hook-form";
import {setFilter} from "../../../redux/actions/generalActions/listActions";

const PathFilters = props => {
    const { app, udn } = props.mainProps
    const { filter } = props.listProps

    const [placeId, setPlaceId] = useState(filter?.item?.place?.id != null ? filter?.item?.place?.id : null);
    const [resetValue, setResetvalue] = useState(false);

    const {handleSubmit, reset} = useForm({
    });

    useEffect(() => {
        onSubmit()
    }, [ app, udn ]);

    const onSubmit = (data, _) => {
        if (app?.fbDataBase?.id === undefined || udn.id === undefined){
            return;
        }

        const dataFilter = {
            fbDataBase : { id : props.mainProps?.app?.fbDataBase?.id },
            item :  {
                udn : { id : '8ae4b22074554d55017455b7db460003' },
            }
        };

        if(placeId != null)
            dataFilter.item.place = { id: placeId }

        props.setFilter(dataFilter);
        props.refreshFiltered(dataFilter);
    };

    const cleanFields = () => {
        setResetvalue(!resetValue);
        props.setFilter({
            fbDataBase : { id : props.mainProps?.app?.fbDataBase?.id },
            item : { }
        });
        reset();
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody>
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>{ FL_PLACE }</Label>
                            <SelectGeneric
                                isDisabled={ false }
                                initialValue={ placeId }
                                setExternalValue={ setPlaceId }
                                provider={ placeProvider }
                                customFilter={ { udn: { id: udn.id } } }
                                resetValue={ true }
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(PathFilters)